<div class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-12">
        <ol class="breadcrumb float-sm-left">
          <li class="breadcrumb-item">
            <a [routerLink]="['/']">
              <i class="fas fa-home"></i>
              Página Inicial</a>
          </li>
          <li class="breadcrumb-item">
            <a [routerLink]="['/tipos-dispensa']">Tipos de Dispensa</a>
          </li>
          <li class="breadcrumb-item active">{{ titulo }}</li>
        </ol>
      </div>
    </div>
  </div>
</div>

<div class="content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card card-outline card-lightblue">
          <div class="card-header">
            <h3 class="card-title mb-0">
              <i *ngIf="this.id" class="fas fa-pencil-alt pr-2"></i>
              <i *ngIf="!this.id" class="far fa-file pr-2"></i>
              {{ titulo }}
            </h3>
          </div>
          <form [formGroup]="form" #f="ngForm" (ngSubmit)="onSubmit()" (keydown.enter)="$event.preventDefault()">
            <div class=" card-body">
              <div class="row">
                <div class="form-group col-md-10">
                  <label for="nome" class="mb-1">Nome</label>
                  <input type="text" id="nome" class="form-control form-control-sm" formControlName="nome"
                    maxlength="100" [ngClass]="{ 'is-invalid': f.submitted && form.controls['nome'].invalid }" />
                  <div *ngIf="f.submitted && form.controls['nome'].invalid" class="invalid-feedback">
                    <div *ngIf="form.controls['nome'].errors.required">Campo obrigatório</div>
                  </div>
                </div>

                <div class="form-group col-md-2">
                  <label for="selectTipo" class="mb-1">Tipo</label>
                  <select id="selectTipo" formControlName="tipoId" class="form-control form-control-sm" [ngClass]="{ 'is-invalid': f.submitted &&
                    form.controls['tipoId'].invalid }">
                    <option *ngFor="let item of enumTipo" [value]="item.codigo">
                      {{item.descricao}}</option>
                  </select>
                  <div *ngIf="f.submitted && form.controls['tipoId'].invalid" class="invalid-feedback">
                    <div *ngIf="form.controls['tipoId'].errors.required">Campo obrigatório</div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-12">
                  <label for="inputDescricao" class="mb-1">Conteúdo</label>
                  <textarea rows="3" id="inputDescricao" class="form-control form-control-sm" formControlName="conteudo"
                    [ngClass]="{ 'is-invalid': f.submitted &&
                    form.controls['conteudo'].invalid }">
                  </textarea>
                  <div *ngIf="f.submitted && form.controls['conteudo'].invalid" class="invalid-feedback">
                    <div *ngIf="form.controls['conteudo'].errors.required">Campo obrigatório</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-footer">
              <button type="submit" class="btn btn-primary btn-sm mr-1">
                <i class="far fa-save"></i> Salvar
              </button>

              <button type="button" class="btn btn-default btn-sm" (click)="onBack()">
                <i class="fas fa-times"></i> Cancelar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
